import { connect, getIn } from 'formik';

import { IMenuItem } from 'shared/types/MenuItem';
import { DropdownMenuSelector } from './DropdownMenuSelector';

export interface IDropdownMenuSelectorProps {
  autoFocus?: boolean;
  'data-qa': string;
  className?: string;
  disabled?: boolean;
  formik?;
  isLoading?: boolean;
  label: string;
  menuItems: Array<IMenuItem>;
  name?: string;
  notFoundMessage?: string;
  onMenuItemClick: (menuItem: IMenuItem) => void;
  selection: IMenuItem;
  displayValue?: string;
  showLabel?: boolean;
}

export const FormikDropdownMenuSelector = ({
  autoFocus,
  className,
  disabled,
  formik,
  isLoading,
  label,
  menuItems,
  name,
  notFoundMessage,
  displayValue,
  showLabel = true,
  onMenuItemClick,
  selection,
  ...props
}: IDropdownMenuSelectorProps) => {
  const hasError = getIn(formik.errors, name) && getIn(formik.touched, name);

  const handleMenuItemClick = (menuItem) => {
    onMenuItemClick(menuItem);
    formik.setFieldValue(name, menuItem.value);
  };

  const handleBlur = () => {
    formik.setTouched({ ...formik.touched, [name]: true });
  };

  return (
    <DropdownMenuSelector
      autoFocus={autoFocus}
      className={className}
      disabled={disabled || !menuItems || menuItems.length === 0}
      hasFormikError={hasError}
      isLoading={isLoading}
      label={label}
      menuItems={menuItems}
      name={name}
      notFoundMessage={notFoundMessage}
      displayValue={displayValue}
      showLabel={showLabel}
      onBlur={handleBlur}
      onMenuItemClick={handleMenuItemClick}
      selection={selection}
      {...props}
    />
  );
};

export default connect(FormikDropdownMenuSelector);
